export default __webpack_public_path__ + "static/tasks-mobile-4c233dc7e8258059d345b68a2205b935.svg";